webpackJsonp([159947537236901],{

/***/ 417:
/***/ (function(module, exports) {

	module.exports = {"data":{"allMarkdownRemark":{"totalCount":1,"edges":[{"node":{"frontmatter":{"title":"Setting off: Rio de Janeiro via Lisbon","path":"/rio-via-lison"}}}]}},"pathContext":{"tag":"flights"}}

/***/ })

});


// WEBPACK FOOTER //
// path---tags-flights-f1a31a871cdf31e65e1b.js